import React from "react";
import styles from "./index.module.scss";

export default function Section({ ...props }) {
  return (
    <section className={styles.section}>
      <div className={styles.sectionContainer}>{props.children}</div>
    </section>
  );
}
